import { useTranslation } from 'react-i18next'

import {
  LightModeSemanticColors,
  Stack,
  Text,
  Tooltip,
} from '@enechain/ecloud-designsystem'
import { FaTriangleExclamationSolid } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

/**
 * 提出後に届いたスポットの約定量が計画と違う行の警告アイコン (AC-PPP-020 / AC-PPL-002。
 * design `procurement.html` の `status-warn-icon--spot-mismatch`)。ツールチップは見出しと
 * 本文 1 文目だけで、時間帯で変わる 2 文目は詳細のバナーにだけ出す。
 *
 * 出すかどうかは呼び出し元が backend の `spotTradeResultMismatch` で決める (版の判定は backend)。
 * click は一覧行の遷移へ伝播させない (`AwaitingMatchResultMark` / `GcExcludedKomaMark` と同じ pattern)。
 */
export const SpotTradeResultMismatchIcon = (): React.ReactElement => {
  const { t } = useTranslation()
  const title = t('page:planSubmission.spotTradeResultMismatch.title')
  return (
    <Tooltip
      content={
        <Stack gap={1}>
          <Text textStyle="captionStrong">{title}</Text>
          <Text textStyle="caption">
            {t('page:planSubmission.spotTradeResultMismatch.body')}
          </Text>
        </Stack>
      }
    >
      {/* アイコンだけの要素なので aria-label を付ける。native button なのは
          tooltip を focus でも出すため (AwaitingMatchResultMark と同じ)。 */}
      <button
        aria-label={title}
        onClick={(e) => {
          e.stopPropagation()
        }}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'help',
          display: 'inline-flex',
          marginRight: '4px',
          padding: 0,
          verticalAlign: 'middle',
        }}
        type="button"
      >
        <FaTriangleExclamationSolid
          boxSize={iconSize.gridInline}
          color={LightModeSemanticColors.Object.warningMid.value}
          aria-hidden="true"
        />
      </button>
    </Tooltip>
  )
}
